import React, { useState, useEffect, useRef } from "react";
import axios from "../../axiosConfig";
import "./CompanyAutocomplete.css";

const CompanyAutocomplete = ({ value = "", onSelect }) => {
  const [inputValue, setInputValue] = useState(value);
  const [companies, setCompanies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await axios.get("/api/companies/");
        setCompanies(res.data || []);
      } catch (err) {
        console.error("Failed to fetch companies", err);
      }
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!inputValue.trim() || selectedCompany) {
      setFiltered([]);
      setShowSuggestions(false);
      return;
    }

    const inputLower = inputValue.toLowerCase();
    const matches = companies
      .filter(c =>
        `${c.name} (${c.ticker})`.toLowerCase().includes(inputLower)
      )
      .slice(0, 3);

    setFiltered(matches);
    setShowSuggestions(matches.length > 0);
  }, [inputValue, companies, selectedCompany]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (company) => {
    const display = `${company.name} (${company.ticker})`;
    setInputValue(display);
    setSelectedCompany(company);
    setShowSuggestions(false);
    if (typeof onSelect === "function") onSelect(company.company_id);
  };

  const handleClear = () => {
    setInputValue("");
    setSelectedCompany(null);
    setShowSuggestions(false);
    if (typeof onSelect === "function") onSelect(null);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setSelectedCompany(null);
    if (typeof onSelect === "function") onSelect(null);
  };

  return (
    <div className="company-autocomplete" ref={wrapperRef}>
      <div className="input-wrapper">
        <input
          type="text"
          placeholder="Type company name or ticker (leave blank to make permanent)"
          value={inputValue}
          onChange={handleChange}
          onFocus={() => {
            if (!selectedCompany && filtered.length > 0) setShowSuggestions(true);
          }}
          autoComplete="off"
          readOnly={!!selectedCompany}
          className={selectedCompany ? "readonly" : ""}
        />

        {selectedCompany && (
          <button className="clear-btn" onClick={handleClear} type="button">
            ×
          </button>
        )}
      </div>

      {showSuggestions && (
        <ul className="suggestions-list">
          {filtered.map((c) => (
            <li
              key={c.company_id}
              onClick={() => handleSelect(c)}
              className="suggestion-item"
            >
              {c.name} ({c.ticker})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CompanyAutocomplete;
